import {
    STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_BEGIN,
  } from '../constants';
  
  export function getYearsDataMaster(brandId, modelId) {
    return (dispatch) => {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_BEGIN,
        data: {brandId, modelId}
      })
    }
  }